import { useAuth } from "@/hooks/useAuth";
import { seesLegacySyncErrors } from "@shared/legacySyncErrors";

/** shared/legacySyncErrors.ts for the signed-in reader: only SaleFish Admins see a Legacy sync error. */
export function useSeesLegacySyncErrors(): boolean {
  const { user } = useAuth();
  return seesLegacySyncErrors(user);
}
